export const NAME = 'products';